import { useCallback, useEffect, useState } from 'react';
import { filmApi } from '../../services/api/film';
import type { BankUsage } from '../../types/film';
import { takeWorkflowHandoff } from '../../services/api/workflowReadHandoff';
import { AK } from './workflowAssetsPreload';

/**
 * "Tập đang mở dùng gì trong bank" — một lượt gọi cho cả 4 màn Bank (260819).
 *
 * Im lặng khi lỗi có chủ đích: bộ lọc là tiện nghi, hỏng nó không đáng làm hỏng cả màn. Lỗi → `usage`
 * là undefined → `filterByEpisode` trả nguyên danh sách, tức là rơi về đúng hành vi trước khi có bộ lọc.
 */
export function useBankUsage(planId?: string,strict=false): { error?:string;usage?: BankUsage; reload: () => void } {
    const [error,setError]=useState<string>();
    const [usage, setUsage] = useState<BankUsage>();

    const reload = useCallback((first?: unknown) => {
        if (!planId) { setUsage(undefined); return; }
        // P3 F1: chỉ lần nạp ĐẦU (effect) lấy từ chỗ giao; `reload()` gọi tay luôn gọi mới.
        (first === true ? takeWorkflowHandoff(AK.bankUsage(planId), () => filmApi.bankUsage(planId)) : filmApi.bankUsage(planId)).then(r=>{setUsage(r);setError(undefined);}).catch(()=>{setUsage(undefined);setError(strict?'Không đọc được nguồn dùng trong tập — tải lại trước khi kết luận.':undefined);});
    }, [planId,strict]);

    useEffect(() => { reload(true); }, [reload]);
    return { usage, reload,error };
}

export default useBankUsage;
